import React, {Component} from "react";
import {connect} from "react-redux";
import {
  pageSizeFilterStyle
} from "../../../services/utils";
import ReactSelect, {components} from "react-select";
import {setEventStatsPageSize} from "../../../actions/actions/eventStats";

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'}/>
    </components.DropdownIndicator>
  );
};

class PageSizeFilter extends Component {

  handleSelectChange = (value) => {
    this.props.setEventStatsPageSize(value.value);
    }

  render() {

    const pageSizeOptions = [
      { value: 5, label: 5},
      { value: 10, label: 10}
    ];

    return (<ReactSelect
        className="my-2 mx-4 event-small-filter"
        onChange={this.handleSelectChange}
        styles={pageSizeFilterStyle()}
        defaultValue={{value: 5, label: 5}}
        options={pageSizeOptions}
        components={{ DropdownIndicator, IndicatorSeparator:() => null, Input:() => null}}
      />
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setEventStatsPageSize,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageSizeFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/PageSizeFilter.js